<template>
  <div>
    <div v-html="licenseItem.itemHTML"></div>
  </div>
</template>

<script>
export default {
  name: 'LicenseAction',
  props: {
    licenseItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/LicenseContent.vue